module.exports = __webpack_public_path__ + "static/media/tcs-logo.653d66a8.jpg";